/**
 * useBootstrap — React Query hook for the dashboard /bootstrap endpoint.
 *
 * Bootstrap is small (catalog + 2 layouts) and rarely changes during a
 * session, so we cache it aggressively. The widget data hooks (built in
 * later phases) refresh independently with their own cache keys.
 */

import { useQuery, type UseQueryResult } from "react-query";
import { fetchBootstrap } from "./api";
import type { BootstrapPayload } from "./types";

export const BOOTSTRAP_KEY = ["dashboard", "bootstrap"] as const;

export function useBootstrap(): UseQueryResult<BootstrapPayload> {
  return useQuery(BOOTSTRAP_KEY, fetchBootstrap, {
    staleTime: 5 * 60 * 1000,    // 5 min — catalog + layout don't change mid-session
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
